"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSavedTaskData = exports.getSaveApi = exports.getLearningTaskData = void 0;
var _urls = require("../../utilities/urls");
const getSaveApi = isLearningActivity => {
  if (isLearningActivity) {
    return `${_urls.apiGatewayUrl}/lmsapi/Tasks/Save`;
  }
  return `${_urls.ofakimApiUrl}/lmscp/saveTask`;
};
exports.getSaveApi = getSaveApi;
const getSavedTaskData = (task, isLearningActivity, teacherId) => {
  if (isLearningActivity) {
    const groups = task.groups?.map(group => {
      return {
        groupId: group.id
      };
    });
    const students = task.students?.map(student => {
      return {
        userId: student.studentID
      };
    });
    let newTask = {};
    if (task.id) {
      newTask.taskId = task.id;
    }
    newTask.name = task.name;
    newTask.activityId = task.item.learningObjectDraft;
    newTask.language = task.item.language;
    newTask.instituteId = task.schoolID;
    newTask.isGradeHidden = task.hideGrade;
    newTask.assessmentTypeEnum = task.taskType === 'learningWork' ? 'nonGraded' : task.taskType === 'evalWork' ? 'graded' : task.taskType;
    newTask.instructions = task.guideLines;
    newTask.startDateTime = task.startDateTime;
    newTask.endDateTime = task.endDateTime;
    newTask.publishDateTime = task.publishDate;
    newTask.feedbackTriggerEnum = task.feedbackType === 'afterTeacherComment' ? 'specifiedDateTime' : task.feedbackType === 'afterSubmitByAll' ? 'teacherChecks' : 'studentSubmits';
    newTask.feedbackSpecifiedDateTime = task.feedbackDate;
    newTask.isPublished = true;
    newTask.studentLmsAudience = {
      groups: groups,
      users: students
    };
    newTask.teacherLmsAudience = {
      users: [{
        userId: teacherId
      }]
    };
    return newTask;
  }
  return task;
};
exports.getSavedTaskData = getSavedTaskData;
const getLearningTaskData = (taskData, unitData) => {
  const task = taskData[0];
  const taskAudience = taskData[1];
  const hasStarted = taskData[2];
  const userGroups = taskData[3]?.value;
  const isReadOnly = new Date(task.endDateTime) < unitData?.schoolYear.startDate;
  const groups = taskAudience?.groups.map(group => {
    const groupSelected = userGroups?.filter(userGroup => userGroup.id === group.groupId);
    return {
      id: group.groupId,
      groupType: groupSelected[0].groupType
    };
  });
  const students = taskAudience?.users.map(user => {
    return {
      studentID: user.userId
    };
  });
  let newTask = {};
  newTask.item = {
    learningObjectDraft: task.activityId,
    language: task.language
  };
  newTask.id = task.taskId;
  newTask.name = task.name;
  newTask.guideLines = task.guideLines;
  newTask.schoolID = task.instituteId;
  newTask.hideGrade = task.isGradeHidden;
  newTask.taskType = task.assessmentTypeEnum === 'nonGraded' ? 'learningWork' : task.assessmentTypeEnum === 'graded' ? 'evalWork' : task.assessmentTypeEnum;
  newTask.feedbackType = task.feedbackTriggerEnum === 'specifiedDateTime' ? 'afterTeacherComment' : task.feedbackTriggerEnum === 'teacherChecks' ? 'afterSubmitByAll' : 'immediate';
  newTask.creationDateTime = new Date(task.createdDateTime);
  newTask.startDateTime = new Date(task.startDateTime);
  newTask.endDateTime = new Date(task.endDateTime);
  newTask.publishDate = new Date(task.publishDateTime);
  if (task.feedbackSpecifiedDateTime) {
    newTask.feedbackDate = new Date(task.feedbackSpecifiedDateTime);
  }
  newTask.isReadOnly = isReadOnly;
  newTask.hasStarted = hasStarted;
  newTask.cannotModifyMembers = hasStarted;
  newTask.IsScheduled = true;
  newTask.groups = groups;
  newTask.students = students;
  return newTask;
};
exports.getLearningTaskData = getLearningTaskData;